import script from "./ContainerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerDetails.vue?vue&type=script&setup=true&lang=js"

import "./ContainerDetails.vue?vue&type=style&index=0&id=d262c918&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d262c918"]])

export default __exports__